import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_b_modal, {
            key: 0,
            modelValue: _ctx.showModal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.showModal) = $event)),
            "hide-header-close": "",
            onHide: _ctx.onHide
        }, {
            title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1 /* TEXT */)
            ]),
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.message), 1 /* TEXT */)
            ]),
            footer: _withCtx(() => [
                _createVNode(_component_b_button, {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleHide(false)))
                }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Cancel", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(_component_b_button, {
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.handleHide(true))),
                    variant: "primary"
                }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("OK", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "onHide"]))
        : _createCommentVNode("v-if", true);
}
